var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingForCourier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.08
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.842 18.8125C142.274 28.8634 136.121 45.9568 145.301 53.3073C154.238 60.4626 164.171 47.552 172.563 53.6774C185.012 62.7644 184.951 107.087 168.751 135.402C163.879 143.918 159.631 147.344 158.131 156.782C154.909 177.048 170.199 188.275 167.876 198.332C162.645 220.979 66.5744 244.393 24.434 179.115C4.75295 148.627 -0.144843 103.471 14.4371 68.2945C40.7854 4.73156 121.409 -3.74078 135.842 18.8125Z",
    fill: "#BB6BD9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.017 104.07L143.129 93.9036L143.886 93.8929L142.875 104.054L142.017 104.07Z",
    fill: "#808285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.955 102.509C145.58 102.249 150.63 102.679 150.63 102.679L150.455 112.102L148.528 112.909L143.372 110.817L144.955 102.509Z",
    fill: "#5C169E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.344 107.037C151.381 109.723 150.704 112.017 150.455 112.102C150.143 112.208 149.708 110.249 149.671 107.563C149.634 104.877 150.301 102.684 150.63 102.679C150.958 102.673 151.302 104.346 151.344 107.037Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8209 131.786L37.3151 131.882L37.2727 128.866C37.2516 127.311 38.4903 126.032 40.0413 126.01L43.7415 125.957L43.8209 131.786Z",
    fill: "#BB6BD9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8555 128.282L48.6221 120.054L59.0928 119.9L69.6694 126.727L71.7445 131.377L49.6067 131.701L49.8555 128.282Z",
    fill: "#BB6BD9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.812 172.174C165.748 172.174 165.685 172.164 165.621 172.137C165.356 172.031 165.229 171.729 165.335 171.463L173.942 149.947C174.048 149.682 174.345 149.549 174.615 149.66C174.879 149.767 175.006 150.069 174.901 150.335L166.293 171.851C166.209 172.052 166.018 172.174 165.812 172.174Z",
    fill: "#6099DC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.846 165.735C180.782 165.735 180.719 165.724 180.655 165.698L159.2 157.066C158.935 156.96 158.808 156.657 158.914 156.392C159.02 156.126 159.322 155.994 159.587 156.105L181.041 164.737C181.306 164.843 181.433 165.146 181.327 165.411C181.243 165.613 181.047 165.735 180.846 165.735Z",
    fill: "#6099DC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.355 172.201C174.149 172.201 173.953 172.079 173.873 171.872L165.398 150.303C165.292 150.037 165.425 149.735 165.69 149.634C165.954 149.533 166.256 149.66 166.356 149.926L174.831 171.495C174.937 171.76 174.805 172.063 174.54 172.164C174.482 172.19 174.419 172.201 174.355 172.201Z",
    fill: "#6099DC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.364 165.666C159.158 165.666 158.962 165.544 158.882 165.337C158.776 165.071 158.909 164.769 159.173 164.668L180.681 156.169C180.946 156.068 181.248 156.195 181.348 156.461C181.454 156.726 181.322 157.029 181.057 157.13L159.549 165.629C159.491 165.655 159.427 165.666 159.364 165.666Z",
    fill: "#6099DC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.411 169.494C178.283 169.494 178.151 169.446 178.051 169.345L161.466 153.196C161.259 152.994 161.259 152.67 161.455 152.463C161.656 152.256 161.979 152.256 162.186 152.453L178.771 168.602C178.977 168.803 178.977 169.127 178.781 169.334C178.68 169.44 178.543 169.494 178.411 169.494Z",
    fill: "#6099DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.064 169.738C161.937 169.738 161.805 169.69 161.704 169.589C161.498 169.387 161.498 169.064 161.693 168.857L177.797 152.224C177.998 152.017 178.321 152.017 178.527 152.214C178.734 152.416 178.734 152.739 178.538 152.946L162.435 169.579C162.334 169.685 162.196 169.738 162.064 169.738Z",
    fill: "#6099DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.559 161.589C158.279 161.589 158.046 161.361 158.046 161.079C158.041 160.793 158.268 160.559 158.554 160.554L181.671 160.214H181.677C181.957 160.214 182.19 160.442 182.19 160.724C182.195 161.01 181.968 161.244 181.682 161.249L158.565 161.589H158.559Z",
    fill: "#6099DC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.285 173.008C170.004 173.008 169.772 172.78 169.772 172.498L169.433 149.315C169.427 149.029 169.655 148.795 169.941 148.79C170.237 148.795 170.46 149.013 170.465 149.299L170.804 172.482C170.809 172.769 170.581 173.003 170.296 173.008C170.29 173.008 170.29 173.008 170.285 173.008Z",
    fill: "#6099DC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.116 165.762C172.791 165.762 174.959 163.587 174.959 160.904C174.959 158.221 172.791 156.047 170.116 156.047C167.441 156.047 165.272 158.221 165.272 160.904C165.272 163.587 167.441 165.762 170.116 165.762Z",
    fill: "url(#paint1_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.217 160.872C172.233 162.035 171.307 162.99 170.147 163.006C168.988 163.022 168.035 162.093 168.019 160.931C168.003 159.768 168.93 158.813 170.089 158.797C171.243 158.781 172.196 159.71 172.217 160.872Z",
    fill: "#5C169E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.867 143.805C179.284 143.667 187.029 151.205 187.166 160.649C187.304 170.093 179.787 177.86 170.37 177.998C160.952 178.136 153.208 170.598 153.065 161.154C152.927 151.71 160.449 143.943 169.867 143.805ZM181.682 160.729C181.587 154.327 176.335 149.209 169.951 149.305C163.567 149.4 158.464 154.666 158.56 161.069C158.655 167.471 163.906 172.589 170.29 172.493C176.674 172.403 181.772 167.137 181.682 160.729Z",
    fill: "#5C169E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8619 125.113L43.7362 125.957C43.7362 125.957 33.7948 131.526 28.3848 151.322L30.3593 151.11C30.3593 151.11 32.969 135.646 43.7679 128.373L68.6001 128.038L62.8619 125.113Z",
    fill: "#9B51E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3179 171.718C54.2544 171.718 54.1909 171.707 54.1273 171.681C53.8627 171.575 53.7356 171.272 53.8415 171.007L62.4488 149.491C62.5547 149.225 62.8565 149.092 63.1211 149.204C63.3858 149.31 63.5129 149.613 63.407 149.878L54.7996 171.394C54.7149 171.596 54.5191 171.718 54.3179 171.718Z",
    fill: "#6099DC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3466 165.279C69.283 165.279 69.2195 165.268 69.156 165.241L47.7011 156.609C47.4364 156.503 47.3094 156.201 47.4152 155.935C47.5211 155.67 47.8175 155.542 48.0875 155.649L69.5424 164.28C69.8071 164.387 69.9341 164.689 69.8283 164.955C69.7436 165.156 69.553 165.279 69.3466 165.279Z",
    fill: "#6099DC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8566 171.744C62.6501 171.744 62.4543 171.622 62.3749 171.415L53.8998 149.846C53.794 149.581 53.9263 149.278 54.191 149.177C54.4557 149.076 54.7574 149.204 54.858 149.469L63.333 171.038C63.4389 171.304 63.3065 171.606 63.0418 171.707C62.9836 171.734 62.9201 171.744 62.8566 171.744Z",
    fill: "#6099DC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8649 165.209C47.6585 165.209 47.4626 165.087 47.3832 164.88C47.2774 164.615 47.4097 164.312 47.6744 164.211L69.1822 155.712C69.4469 155.611 69.7486 155.739 69.8492 156.004C69.9551 156.27 69.8227 156.572 69.558 156.673L48.0502 165.172C47.992 165.199 47.9285 165.209 47.8649 165.209Z",
    fill: "#6099DC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9115 169.037C66.7844 169.037 66.6521 168.989 66.5515 168.888L49.9667 152.739C49.7603 152.543 49.7603 152.214 49.9561 152.007C50.1573 151.8 50.4802 151.8 50.6867 151.996L67.2715 168.145C67.4779 168.342 67.4779 168.671 67.282 168.878C67.1815 168.984 67.0491 169.037 66.9115 169.037Z",
    fill: "#6099DC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5703 169.276C50.4433 169.276 50.311 169.228 50.2104 169.127C50.0039 168.926 50.0039 168.602 50.1998 168.395L66.3029 151.763C66.5041 151.556 66.827 151.556 67.0334 151.752C67.2399 151.954 67.2398 152.278 67.044 152.485L50.9409 169.117C50.835 169.223 50.7027 169.276 50.5703 169.276Z",
    fill: "#6099DC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0604 161.132C46.7799 161.132 46.547 160.904 46.547 160.623C46.5417 160.336 46.7693 160.103 47.0552 160.097L70.1722 159.757C70.4422 159.768 70.691 159.98 70.6963 160.267C70.7016 160.554 70.474 160.787 70.1881 160.793L47.071 161.132C47.0657 161.132 47.0657 161.132 47.0604 161.132Z",
    fill: "#6099DC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7913 172.551C58.5108 172.551 58.2778 172.323 58.2778 172.042L57.9391 148.859C57.9338 148.572 58.1614 148.339 58.4472 148.333C58.7384 148.307 58.966 148.556 58.9713 148.843L59.3101 172.026C59.3154 172.312 59.0878 172.546 58.8019 172.551C58.7966 172.551 58.7913 172.551 58.7913 172.551Z",
    fill: "#6099DC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.622 165.3C61.297 165.3 63.4656 163.125 63.4656 160.442C63.4656 157.76 61.297 155.585 58.622 155.585C55.9469 155.585 53.7783 157.76 53.7783 160.442C53.7783 163.125 55.9469 165.3 58.622 165.3Z",
    fill: "url(#paint2_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1125 161.918C60.9211 161.083 60.9015 159.749 60.0688 158.938C59.2362 158.127 57.9057 158.147 57.0972 158.982C56.2887 159.817 56.3083 161.151 57.141 161.962C57.9736 162.773 59.304 162.753 60.1125 161.918Z",
    fill: "#5C169E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3731 143.348C67.7903 143.21 75.5349 150.749 75.6725 160.193C75.8101 169.637 68.2932 177.403 58.8759 177.542C49.4586 177.68 41.7141 170.141 41.5712 160.697C41.4336 151.253 48.9505 143.486 58.3731 143.348ZM70.183 160.272C70.0878 153.87 64.8365 148.753 58.4524 148.848C52.0684 148.944 46.9654 154.21 47.0606 160.612C47.1559 167.014 52.4072 172.132 58.7912 172.036C65.1806 171.946 70.2783 166.675 70.183 160.272Z",
    fill: "#5C169E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5698 137.673C75.2064 128.781 59.8339 131.553 47.0446 131.68C42.0156 131.728 37.6749 135.364 34.2658 139.76C33.4612 141.427 32.7201 143.301 32.1113 145.398C32.1378 147.043 34.7687 150.345 38.5325 148.97C38.5325 148.97 58.7804 137.918 74.3595 155.611L75.6987 161.695L88.721 162.672C88.6627 156.201 87.8211 144.012 82.5698 137.673Z",
    fill: "#8537CD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M113.204 159.689L107.312 153.392L101.098 140.333C101.098 140.333 100.177 131.245 103.919 127.486L78.7852 127.858L43.7734 128.373C43.7734 128.373 38.2257 131.542 34.2661 139.755C37.6752 135.364 42.0159 131.728 47.0448 131.675C59.8342 131.547 75.2067 128.776 82.5701 137.668C87.8213 144.007 88.663 156.195 88.716 162.672L92.9191 162.985L113.204 159.689Z",
    fill: "url(#paint3_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9563 117.15L30.8305 117.596L30.4282 90.1663L60.5488 89.7203L60.9563 117.15Z",
    fill: "url(#paint4_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0631 117.916L34.1011 118.284L34.1303 120.275L59.0923 119.907L59.0631 117.916Z",
    fill: "#782388"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6017 93.0383L30.4759 93.4842L30.4282 90.1663L60.5488 89.7203L60.6017 93.0383Z",
    fill: "url(#paint5_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8516 119.033L44.9673 119.061L45.1529 131.721L47.0372 131.693L46.8516 119.033Z",
    fill: "#5C169E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.735 159.131C150.735 159.131 156.495 145.769 181.422 143.221C181.422 143.221 172.847 132.253 152.805 139.091C152.805 139.091 145.913 152.564 150.735 159.131Z",
    fill: "#8437CD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M165.028 147.033L171.031 161.079L169.782 161.6L163.096 145.599L164.208 144.93L165.028 147.033Z",
    fill: "#5876D6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M161.576 135.274L165.954 145.769L162.445 147.341L157.929 135.9C157.929 135.895 159.607 134.414 161.576 135.274Z",
    fill: "#5C169E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M165.409 134.541L165.891 133.05C165.891 133.05 158.295 118.881 148.528 112.903L147.109 114.108L165.409 134.541Z",
    fill: "#5C169E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M142.017 104.07L139.455 109.798L140.693 116.481C143.885 120.606 146.919 125.161 149.11 132.036C149.11 132.036 136.289 152.076 130.408 155.07C130.408 155.07 117.814 156.27 108.958 153.998L107.312 153.387C107.312 153.387 109.054 155.893 108.932 156.461C108.815 157.034 101.796 159.853 88.6521 157.899C88.6521 157.899 87.768 160.012 88.7156 162.672L142.541 165.698C142.541 165.698 150.936 140.535 165.409 134.536C161 126.637 155.166 119.507 147.072 111.666L144.949 102.498L142.017 104.07Z",
    fill: "url(#paint6_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M142.017 104.07C142.017 104.07 139.555 103.788 138.825 105.636C138.094 107.478 140.487 109.277 140.487 109.277L142.472 105.073L142.017 104.07Z",
    fill: "#5C169E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M141.678 107.08L138.216 108.927L138.65 111.045L142.531 108.805C142.531 108.805 143.007 108.46 142.928 107.727C142.864 107.133 142.202 106.798 141.678 107.08Z",
    fill: "#414042"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5094 128.973L105.528 127.672C106.174 127.534 106.645 126.977 106.666 126.313C106.735 124.259 106.433 120.049 102.913 119.247C98.9959 118.355 72.4433 117.405 63.7195 117.113C61.3003 117.033 59.0611 118.515 58.2989 120.818C57.4678 123.335 58.4259 126.456 66.6098 128.033C81.6648 130.942 99.5094 128.973 99.5094 128.973Z",
    fill: "#8437CD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M143.092 91.3448L142.779 97.1206C142.779 97.1206 144.87 96.4942 145.029 94.4398C145.045 94.1743 144.113 92.2791 143.092 91.3448Z",
    fill: "#5C169E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M113.252 69.1281L108.456 64.4724C110.351 62.4657 111.796 60.2148 112.664 57.6561L117.571 63.7079C115.888 64.9289 114.406 66.6224 113.252 69.1281Z",
    fill: "#F8A595"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M124.733 59.0416C124.733 59.0416 125.263 62.3011 125.495 63.6177L123.521 63.3894L124.733 59.0416Z",
    fill: "#F8A595"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M124.431 62.9063C124.214 63.8035 123.055 66.6277 123.055 66.6277C122.272 67.339 121.557 67.4983 120.504 67.4027C117.952 67.1585 115.559 65.8101 113.897 63.8512C112.235 61.8977 111.288 59.376 111.076 56.8173C110.806 53.5684 111.997 49.8736 114.935 48.4774C117.899 47.0759 123.436 48.1482 125.21 51.0892C127.073 54.1789 125.21 59.6893 124.431 62.9063Z",
    fill: "#F7A08C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M126.962 50.7548L131.287 53.7224L131.224 54.301L121.923 53.234L126.962 50.7548Z",
    fill: "#5C169E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M131.398 108.125C132.753 109.373 134.638 110.021 136.475 109.867C136.205 109.235 136.633 108.423 137.29 108.226C137.946 108.03 138.708 108.402 139.026 109.012C139.344 109.623 139.248 110.408 138.857 110.976C138.269 110.902 137.676 110.875 137.083 110.897C137.464 112.192 139.079 112.797 140.392 112.489C141.705 112.181 142.758 111.215 143.679 110.228C143.838 110.058 144.002 109.872 144.044 109.644C144.108 109.315 143.912 108.996 143.721 108.72C142.89 107.542 141.927 106.459 140.858 105.492C140.545 105.211 140.206 104.935 139.804 104.834C139.37 104.728 138.915 104.845 138.475 104.93C136.792 105.269 134.442 104.823 132.78 104.383L131.398 108.125Z",
    fill: "#F7A08C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M123.426 52.9261C123.458 53.1225 119.668 61.4677 119.668 61.4677L108.091 60.1352C108.091 60.1352 102.612 44.8038 114.019 43.2537C125.427 41.7036 127.603 50.1603 127.788 51.0415C127.973 51.9227 123.426 52.9261 123.426 52.9261Z",
    fill: "url(#paint7_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M119.021 67.132L117.248 66.4684L117.973 60.1246L119.8 60.3369L119.021 67.132Z",
    fill: "#5C169E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M122.637 151.481L121.001 157.73L120.652 160.793L139.91 163.006C140.111 161.239 138.936 159.566 137.115 159.025L132.986 157.804L129.72 153.923L129.423 152.586L122.637 151.481Z",
    fill: "#5C169E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M104.841 109.506C105.984 109.187 107.006 108.917 107.922 108.688C108.361 107.09 117.297 74.373 113.252 69.1281L110.002 64.3662C110.002 64.3662 102.925 59.546 95.7305 80.8602C91.5274 93.309 87.5413 102.196 86.8638 108.269C90.8551 109.23 99.5366 110.987 104.841 109.506Z",
    fill: "url(#paint8_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M139.926 121.843C139.635 116.067 107.905 108.752 107.905 108.752C107.905 108.752 107.91 108.725 107.921 108.688C107.011 108.895 105.989 109.14 104.851 109.426C99.5624 110.764 90.8757 109.06 86.879 108.131C86.429 112.155 87.2443 116.625 91.2515 118.27C100.886 122.231 127.867 126.101 127.867 126.101L122.521 151.922L129.424 152.586C129.424 152.586 140.217 127.619 139.926 121.843Z",
    fill: "url(#paint9_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M113.522 95.6395C112.992 89.6885 112.463 83.7375 111.933 77.7865C109.975 73.5396 107.646 73.4493 105.073 76.024C104.544 82.5271 105.015 89.1099 106.455 95.475C106.693 96.5208 106.963 97.5772 107.54 98.4797C108.127 99.4034 108.99 100.109 109.88 100.746C116.428 105.439 124.352 107.319 132.261 108.794C132.515 107.319 133.039 105.556 133.293 104.08C126.845 101.06 120.26 97.9435 113.522 95.6395Z",
    fill: "url(#paint10_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M139.418 109.925C139.433 110.859 138.687 111.629 137.755 111.645C136.824 111.661 136.056 110.913 136.04 109.978C136.024 109.044 136.771 108.274 137.702 108.258C138.634 108.242 139.402 108.991 139.418 109.925Z",
    fill: "#5C169E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.228 37C148.99 37 139.874 44.1083 139.874 52.8729C139.874 56.4881 141.441 59.8113 144.051 62.4816L137 68.7458L147.227 65.0881C150.753 67.3709 155.279 68.7458 160.223 68.7458C171.461 68.7458 180.577 61.6375 180.577 52.8729C180.582 44.1083 171.467 37 160.228 37Z",
    fill: "url(#paint11_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.832 52.5384C151.832 53.8762 150.747 54.9645 149.413 54.9645C148.079 54.9645 146.994 53.8762 146.994 52.5384C146.994 51.2007 148.079 50.1124 149.413 50.1124C150.747 50.1071 151.832 51.1954 151.832 52.5384Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.647 52.5384C162.647 53.8762 161.562 54.9645 160.228 54.9645C158.894 54.9645 157.809 53.8762 157.809 52.5384C157.809 51.2007 158.894 50.1124 160.228 50.1124C161.562 50.1071 162.647 51.1954 162.647 52.5384Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.462 52.5384C173.462 53.8762 172.377 54.9645 171.043 54.9645C169.709 54.9645 168.624 53.8762 168.624 52.5384C168.624 51.2007 169.709 50.1124 171.043 50.1124C172.377 50.1071 173.462 51.1954 173.462 52.5384Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41.5,
    y1: 25.5,
    x2: 196.5,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36BBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 165.274,
    y1: 160.902,
    x2: 174.96,
    y2: 160.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 53.7782,
    y1: 160.443,
    x2: 63.464,
    y2: 160.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 34.2633,
    y1: 145.238,
    x2: 113.202,
    y2: 145.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB6BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B51E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 30.4262,
    y1: 103.657,
    x2: 60.9539,
    y2: 103.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6BD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 21.4213,
    y1: 91.3539,
    x2: 51.6209,
    y2: 91.6611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6BD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 88.2771,
    y1: 134.105,
    x2: 165.41,
    y2: 134.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB6BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B51E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 106.778,
    y1: 52.2667,
    x2: 127.793,
    y2: 52.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6BD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 94.8491,
    y1: 84.7414,
    x2: 113.212,
    y2: 92.6878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36BBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#289AB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 118.617,
    y1: 103.678,
    x2: 111.041,
    y2: 123.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 126.032,
    y1: 77.2069,
    x2: 115.516,
    y2: 98.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36BBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#289AB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 137.005,
    y1: 52.8742,
    x2: 180.58,
    y2: 52.8742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6BD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingForCourier);
export default __webpack_public_path__ + "static/media/LoadingForCourier.5b1d6501946961e5ebb2260520f171c3.svg";
export { ForwardRef as ReactComponent };